function NCPListFilterQuery(queryString) {
  const queryStringDecoded = queryString?.replace(/%3A/gi, ':');

  // Parse the query string to get the 'q' parameter
  const urlParams = new URLSearchParams(queryStringDecoded);
  const query = urlParams.get('q');

  if (!query) {
    return queryString; // Return the original query string if 'q' is not present
  }

  // Split the query into parts
  const queryParts = query.split(':');

  // Remove 'bodyType' and its associated value
  const filteredParts = [];
  for (let i = 0; i < queryParts.length; i++) {
    if (queryParts[i] === 'bodyType') {
      i++; // Skip the next part (the value of bodyType)
    } else {
      filteredParts.push(queryParts[i]);
    }
  }

  // Reconstruct the query string
  const newQuery = filteredParts.join(':');
  urlParams.set('q', newQuery);

  return `?${urlParams.toString()}`;
}

export default NCPListFilterQuery;
